/* ══════════════════════════════════════════════════════════════
   Wishlist — Verychi   (localStorage, no app dependency)
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var STORAGE_KEY = 'verychi_wishlist';

  /* ── SVG icons ── */
  var ICON_OUTLINE = '<svg class="wl-icon-outline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>';
  var ICON_FILLED = '<svg class="wl-icon-filled" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>';
  var ICONS_BOTH = ICON_OUTLINE + ICON_FILLED;

  /* ── Storage helpers ── */
  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  var syncTimeout = null;
  function syncToShopify(list) {
    if (typeof window.VerychiCustomerID === 'undefined' || !window.VerychiCustomerID) return; /* Not logged in */
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(function () {
      console.log("Verychi Uploading Wishlist to CF:", list);
      fetch('https://verychi-tryon.ilian-vezirski.workers.dev', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: window.VerychiCustomerID,
          wishlist: list
        })
      }).catch(function(err) {
        console.error("Verychi CF Upload Error:", err);
      });
    }, 1000);
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      syncToShopify(list);
    } catch (e) { /* quota */ }
  }

  function normalizeColor(color) {
    return String(color || '').trim().toLowerCase();
  }

  function getItemKey(handle, color) {
    return String(handle || '') + '||' + normalizeColor(color);
  }

  function getLegacyKey(item) {
    if (item && item.key) return item.key;
    return getItemKey(item && item.handle, item && item.color);
  }

  function isInWishlist(handle, color) {
    var key = getItemKey(handle, color);
    return getList().some(function (item) { return getLegacyKey(item) === key; });
  }

  function addItem(handle, title, img, url, price, color, video) {
    var list = getList();
    var key = getItemKey(handle, color);
    if (list.some(function (item) { return getLegacyKey(item) === key; })) return list;
    list.push({
      key: key,
      handle: handle,
      color: String(color || '').trim(),
      title: title,
      img: img,
      video: video || '',
      url: url,
      price: price,
      ts: Date.now()
    });
    saveList(list);
    return list;
  }

  function removeItem(handle, color) {
    var key = getItemKey(handle, color);
    var list = getList().filter(function (item) { return getLegacyKey(item) !== key; });
    saveList(list);
    return list;
  }

  function removeItemByKey(key) {
    var list = getList().filter(function (item) { return getLegacyKey(item) !== key; });
    saveList(list);
    return list;
  }

  function toggleItem(handle, title, img, url, price, color, video) {
    if (isInWishlist(handle, color)) {
      removeItem(handle, color);
      showToast('Премахнато от любими');
      return false;
    } else {
      addItem(handle, title, img, url, price, color, video);
      showToast('Добавено в любими');
      return true;
    }
  }

  /* ── Price formatter (mirrors price-eur-bgn.liquid) ── */
  function formatPrice(val) {
    if (!val) return '';
    var str = String(val).replace(/[^\d.,]/g, '').replace(',', '.');
    var num = parseFloat(str);
    if (!num || isNaN(num)) return String(val);
    /* product.price from Shopify Liquid is always in cents (integer) */
    var cents = Math.round(num);
    var eurW = Math.floor(cents / 100);
    var eurF = cents % 100;
    var bgnTotal = Math.round(cents * 1.95583);
    var bgnW = Math.floor(bgnTotal / 100);
    var bgnF = bgnTotal % 100;
    var eur = eurW + '.' + (eurF < 10 ? '0' + eurF : eurF) + ' \u20AC';
    var bgn = bgnW + '.' + (bgnF < 10 ? '0' + bgnF : bgnF) + ' \u043B\u0432';
    return eur + ' / ' + bgn;
  }

  /* ── Toast ── */
  var toastEl = null, toastTimer = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wl-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('wl-toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('wl-toast--show');
    }, 2000);
  }

  /* ── Update all buttons state ── */
  function syncAllButtons() {
    var all = document.querySelectorAll('[data-wl-handle]');
    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      var h = btn.getAttribute('data-wl-handle');
      var c = btn.getAttribute('data-wl-color') || '';
      if (isInWishlist(h, c)) {
        btn.classList.add('wl-active');
      } else {
        btn.classList.remove('wl-active');
      }
    }
    updateHeaderBadge();
  }

  /* ── Header badge ── */
  function updateHeaderBadge() {
    var badges = document.querySelectorAll('.wl-header-count');
    var count = getList().length;
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      if (count > 0) {
        badges[i].classList.add('wl-header-count--visible');
      } else {
        badges[i].classList.remove('wl-header-count--visible');
      }
    }
  }

  /* ── Collection card buttons: delegate ── */
  function initCollectionButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wl-card-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.getAttribute('data-wl-handle');
      var color = btn.getAttribute('data-wl-color') || '';
      var title = btn.getAttribute('data-wl-title') || '';
      var img = btn.getAttribute('data-wl-img') || '';
      var video = btn.getAttribute('data-wl-video') || '';
      var url = btn.getAttribute('data-wl-url') || '';
      var price = btn.getAttribute('data-wl-price') || '';

      var added = toggleItem(handle, title, img, url, price, color, video);
      syncAllButtons();
    });
  }

  /* ── Product page: wishlist icon inside ATC button ── */
  function initProductPage() {
    var wlIcon = document.querySelector('.pp-wl-icon[data-wl-handle]');
    if (!wlIcon) return;

    function toggleFromIcon() {
      var handle = wlIcon.getAttribute('data-wl-handle');
      var color = wlIcon.getAttribute('data-wl-color') || '';
      var title = wlIcon.getAttribute('data-wl-title') || '';
      var img = wlIcon.getAttribute('data-wl-img') || '';
      var video = wlIcon.getAttribute('data-wl-video') || '';
      var url = wlIcon.getAttribute('data-wl-url') || '';
      var price = wlIcon.getAttribute('data-wl-price') || '';
      toggleItem(handle, title, img, url, price, color, video);
      syncAllButtons();
    }

    wlIcon.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleFromIcon();
    });

    var atcBtn = wlIcon.closest('.btn.add-to-cart');
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        /* If click was on the wishlist icon area, toggle wishlist instead of submit */
        if (e.target.closest('.pp-wl-icon') || e.target.closest('.pp-wl-divider')) {
          e.preventDefault();
          e.stopPropagation();
          toggleFromIcon();
        }
      });
    }

    syncAllButtons();
  }

  /* ── Wishlist page rendering ── */
  function initWishlistPage() {
    var container = document.getElementById('WishlistPageContainer');
    if (!container) return;

    function render() {
      var list = getList();
      if (list.length === 0) {
        container.innerHTML = '<p class="wl-page__empty">Нямате добавени любими продукти.</p>';
        updateHeaderBadge();
        return;
      }

      var html = '<div class="wl-page__grid">';
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var itemKey = getLegacyKey(item);
        var mediaHtml = '';
        if (item.video) {
          mediaHtml = '<video class="wl-card__video" autoplay muted loop playsinline preload="metadata">'
            + '<source src="' + item.video + '" type="video/mp4">'
            + '</video>';
        } else {
          mediaHtml = '<img src="' + item.img + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">';
        }
        html += '<div class="wl-card" data-wl-card-key="' + itemKey + '">'
          + '<div class="wl-card__img-wrap">'
          + '<a href="' + item.url + '">'
          + mediaHtml
          + '</a>'
          + '<button type="button" class="wl-card__remove" data-wl-remove-key="' + itemKey + '" aria-label="Премахни">&times;</button>'
          + '</div>'
          + '<div class="wl-card__info">'
          + '<a href="' + item.url + '" class="wl-card__title">' + item.title + '</a>'
          + (item.price ? '<span class="wl-card__price">' + formatPrice(item.price) + '</span>' : '')
          + '</div>'
          + '</div>';
      }
      html += '</div>';
      container.innerHTML = html;

      /* Remove buttons */
      var removeBtns = container.querySelectorAll('.wl-card__remove');
      for (var j = 0; j < removeBtns.length; j++) {
        removeBtns[j].addEventListener('click', function (e) {
          var key = this.getAttribute('data-wl-remove-key');
          removeItemByKey(key);
          showToast('Премахнато от любими');
          render();
          syncAllButtons();
        });
      }
      updateHeaderBadge();
    }

    render();
  }

  /* ── Merge Local and Remote on Load ── */
  function initializeSync() {
    if (typeof window.VerychiCustomerID === 'undefined' || !window.VerychiCustomerID) return;
    
    fetch('https://verychi-tryon.ilian-vezirski.workers.dev?customerId=' + window.VerychiCustomerID)
      .then(function(res) { return res.json(); })
      .then(function(remoteList) {
        console.log("Verychi Remote Wishlist:", remoteList);
        if (!Array.isArray(remoteList)) remoteList = [];

        var localList = getList();
        var localKeys = {};
        for (var i = 0; i < localList.length; i++) {
          localKeys[getLegacyKey(localList[i])] = true;
        }
        var merged = false;

        for (var j = 0; j < remoteList.length; j++) {
          var ritem = remoteList[j];
          if (!localKeys[getLegacyKey(ritem)]) {
            localList.push(ritem);
            merged = true;
          }
        }

        if (merged) {
          saveList(localList);
          /* Re-render wishlist page if on it */
          if (document.querySelector('[data-wishlist-grid]')) {
            renderWishlistPage();
          }
          /* Update all heart icons */
          document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
            var h = btn.getAttribute('data-handle');
            var c = btn.getAttribute('data-color');
            var k = (h + '||' + c).toLowerCase();
            var inList = localList.some(function(item) { return getLegacyKey(item) === k; });
            btn.classList.toggle('is-wishlisted', inList);
          });
          updateHeaderBadge();
        } else if (localList.length !== remoteList.length) {
          syncToShopify(localList);
        }
      })
      .catch(function(err) {
        console.error("Verychi Wishlist Fetch Error:", err);
      });
  }

  /* ── Boot ── */
  function boot() {
    initializeSync();
    initCollectionButtons();
    initProductPage();
    initWishlistPage();
    syncAllButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Listen for storage changes (other tabs) */
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      syncAllButtons();
      var container = document.getElementById('WishlistPageContainer');
      if (container) initWishlistPage();
    }
  });

  /* Expose globally for dynamic elements */
  window.VerychiWishlist = {
    isInWishlist: isInWishlist,
    toggle: toggleItem,
    syncAll: syncAllButtons,
    getList: getList
  };
})();
